module.exports = __webpack_public_path__ + "img/add-driver.c3570547.svg";